import { getLocalizedRouteName } from './getLocalizedRouteName.js';
export function defineLocalizedRoute(route) {
    const routeLocationFactory = (options) => {
        if (!options) {
            return { name: route.name };
        }
        const { $query: query, locale, ...params } = options;
        return {
            name: getLocalizedRouteName(route.name, locale),
            params: params,
            query,
        };
    };
    const routeDefinition = routeLocationFactory;
    routeDefinition.route = route;
    return routeDefinition;
}
//# sourceMappingURL=defineLocalizedRoute.js.map